import React from 'react'
import { Row, Col } from 'antd'
import PortImg from '../images/innerImg.png'

function CraftMission({ data }) {
    return (
        <div>
            <section className="doubleTheme">
                <div className="container">
                    <Row
                        gutter={[20, 20]} // Add vertical gutter for spacing between rows
                        style={{ overflowX: 'hidden' }}
                        align="middle" // Align items vertically to the center
                        justify="center" // Center the content horizontally
                    >
                        {/* Text Content Column */}
                        <Col xs={24} sm={24} md={24} lg={18} xl={18}>
                            <div className="themeBack">
                                <h2>{data.title}</h2>
                                {data.description.map((item, ind) => <p key={ind}>{item}</p>)}
                            </div>
                        </Col>

                        {/* Image Column */}
                        <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                            <div className="theme-img">
                                <img src={data.image} alt="img" style={{ width: '100%', height: 'auto' }} />
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>
        </div>
    )
}

export default CraftMission
